import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { useTranslation } from "react-i18next";
import { InstumentTuneStyled } from "./styled";
import moment from "moment";
import {
  RENDER_SUB_TASK_STATUS,
  SERVICES_SUB_TASK_RENDER_PROMOTION,
} from "utils/functions/serviceTask";

const InstumentTune = ({ theme_standard, data }) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });

  const { t, i18n } = useTranslation(["profile", "common"]);

  return (
    <>
      <InstumentTuneStyled lang={i18n.language}>
        <div className={customClass}>
          <div className="tune_history">
            <div className="tune_title">{t("Piano tuning history", { ns: "common" })}</div>
            <div className="tune_sub_title">{t("Details", { ns: "common" })}</div>
            {data &&
              data.map((e, i) => (
                <div className="tune_row_history" key={i}>
                  <div className="date_wrap">
                    <div className="id">{i + 1}.</div>
                    <div className="date">
                      {moment(e.appointment_date).format("DD/MM/YYYY")}
                    </div>
                  </div>
                  <div className="tune_status">
                    {i18n.language === "en"
                      ? RENDER_SUB_TASK_STATUS(e.status).en
                      : RENDER_SUB_TASK_STATUS(e.status).th}
                  </div>
                  <div className="tune_detail">
                    {i18n.language === "en"
                      ? SERVICES_SUB_TASK_RENDER_PROMOTION(e.promotion_type).en
                      : SERVICES_SUB_TASK_RENDER_PROMOTION(e.promotion_type).th}
                  </div>
                </div>
              ))}
          </div>
        </div>
      </InstumentTuneStyled>
    </>
  );
};

InstumentTune.propTypes = {};

export default InstumentTune;
